import { useShallow } from 'zustand/shallow';
import { useStore } from './store.js';

export function usePinned(threadURN) {
  return useStore(
    useShallow(s => {
      const ann = s.annotationsByThread[threadURN];
      if (!ann) return [];
      return [...ann.pinned];
    }),
  );
}
